import { StatsAndErrors } from '@/components/mapping'

const dropdownRequired = {
  validate: (value, args) => {
    var trimmedValue = value.trim().toLowerCase()
    return trimmedValue !== ''
  },
  getMessage: field => {
    return field + ' is required'
  }
}

const fieldMapping = {
  validate (mappingDoc, { lhsValues, rhsValues } = {}) {
    const stats = StatsAndErrors(mappingDoc, lhsValues, rhsValues)
    return stats.isValid
  },
  getMessage: field => {
    return `${field} has an incomplete mapping`
  }
}
const fieldMappingParamNames = ['lhsValues', 'rhsValues']

const appValidations = {
  dropdownRequired: [dropdownRequired, {}],
  fieldMapping: [fieldMapping, { fieldMappingParamNames }]
}

export default function (veeValidator) {
  Object.keys(appValidations).forEach(ruleName => {
    veeValidator.extend(ruleName, appValidations[ruleName][0], appValidations[ruleName][1])
  })
}
